<!-- 短信快捷登录 -->
<template>
  <div class="reg-code">
    <p class="title">验证码</p>
    <div class="reg-num">
      <input type="text" placeholder="请输入验证码" />
      <van-button
        plain
        :class="disabled?'get-code disable':'get-code'"
        @click="getCode"
        :disabled="disabled"
      >
        {{disabled?'重新获取':'获取验证码'}}
        <van-count-down :time="time" format="ss" @finish="finish" v-show="disabled" />
      </van-button>
    </div>
    <!-- 弹窗 -->
    <van-dialog v-model="show" show-cancel-button>
      <input type="text" placeholder="请输入图形验证码" />
      <img src="../../assets/img/enimg/code.png" class="code-img" />
    </van-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      show: false,
      time: 10 * 1000,
      disabled: false
    };
  },
  computed: {},
  methods: {
    //   获取验证码
    getCode() {
      var that = this;
      that.show = true;
      that.disabled = true;
    },
    //   倒计时结束
    finish() {
      this.disabled = false;
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.reg-code {
  margin-top: 0.4rem;
  .title {
    font-size: 0.28rem;
    font-weight: bold;
  }
  .reg-num {
    display: flex;
    // justify-content: space-between;
    margin-top: 0.19rem;
    input {
      padding: 0.19rem 0;
      border-bottom: 0.01rem solid rgba(178, 178, 178, 0.5) !important;
      flex: 3;
      font-size: 0.24rem;
    }
    input::-webkit-input-placeholder {
      font-size: 0.24rem;
      font-weight: 400;
      color: rgba(204, 204, 204, 1);
    }
    .van-button {
      height: 0.64rem;
      align-self: flex-end;
    }
    /deep/.van-button__text {
      display: flex;
      align-items: center;
    }
    .get-code {
      border: 0.01rem solid #ff4343 !important;
      border-radius: 0.08rem;
      color: rgba(255, 67, 67, 1);
      font-size: 0.24rem;
      flex: 1;
      margin-left: 0.2rem;
    }
    .disable {
      border: 0.01rem solid #dedede !important;
      color: #808080;
    }
  }
  /deep/.van-dialog__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.64rem 0.3rem;
    box-sizing: border-box;
    input {
      height: 0.64rem;
      width: 90%;
      border: 1px solid rgba(222, 222, 222, 1) !important;
      border-radius: 0.08rem;
      padding: 0.2rem 0.28rem;
    }
  }
  .code-img {
    widows: 1.48rem;
    height: 0.64rem;
    margin-left: 0.33rem;
  }
}
</style>